import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

const AddWorkingHrs = (props) => {
  const { showHide, handleShowHide, handleSelect, selectedObj } = props;

  const [hour, setHour] = useState("");
  const [minutes, setMinutes] = useState("");

  useEffect(() => {
    if (selectedObj?.title) {
      const wrkHr = selectedObj.title.toString().split(".");
      setHour(wrkHr[0] ?? "");
      setMinutes(wrkHr[1] ?? "");
    } else {
      setHour("");
      setMinutes("");
    }
  }, [selectedObj]);

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = date instanceof Date ? date : new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return "Invalid Date";
  };

  const doSubmit = () => {
    // Treat empty minutes as 0 when composing the value to send
    const hrNum = hour === "" ? 0 : Number(hour);
    const minStr = minutes === "" ? "0" : minutes.toString();
    let wrkHr;

    if (hrNum === 24) {
      // Force minutes to 0 when hr is 24
      wrkHr = "24.0";
    } else if (minStr && minStr !== "0") {
      wrkHr = `${hrNum}.${minStr}`;
    } else {
      wrkHr = hrNum; // integer number when minutes is 0 or empty
    }

    handleSelect(wrkHr);
  };

  // Normalize to numbers for validation (empty string => 0)
  const hrNum = hour === "" ? 0 : Number(hour);
  const minNum = minutes === "" ? 0 : Number(minutes);

  const bothEmpty = hour === "" && minutes === "";
  const zeroZero = hrNum === 0 && minNum === 0;
  const outOfRange = hrNum < 0 || hrNum > 24 || minNum < 0 || minNum > 59;
  const twentyFourInvalid = hrNum === 24 && minNum !== 0;

  const isInvalid = bothEmpty || zeroZero || outOfRange || twentyFourInvalid;

  return (
    <Modal show={showHide} size="xl">
      <Modal.Header closeButton onHide={() => handleShowHide("")}>
        <Modal.Title>
          <span style={{ paddingBottom: "5px" }}>Add/Edit Hours and Minutes</span>
          <br />
          <span style={{ paddingTop: "5px", fontSize: "14px" }}>
            {formatDate(selectedObj?.start)}
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="border">
        <div className="row">
          {/* Hour Input */}
          <div className="col-md-6">
            <label htmlFor="hour" className="form-control-label">Enter Hour</label>
            <input
              type="number"
              id="hour"
              name="hour"
              className="form-control"
              placeholder="Enter Hour"
              value={hour}
              onChange={({ currentTarget }) => {
                let val = currentTarget.value;
                if (val === "") {
                  setHour("");
                  // if user clears hour, don't touch minutes
                  return;
                }
                // keep as string but clamp numeric range
                const n = Number(val);
                if (isNaN(n)) return;
                if (n < 0) val = "0";
                if (n > 24) val = "24";
                setHour(val);
                if (val === "24") {
                  setMinutes("0"); // force minutes to 0 for 24 hours
                }
              }}
            />
          </div>

          {/* Minutes Input */}
          <div className="col-md-6">
            <label htmlFor="minutes" className="form-control-label">Enter Minutes</label>
            <input
              type="number"
              id="minutes"
              name="minutes"
              className="form-control"
              placeholder="Enter Minutes"
              value={hour === "24" ? "0" : minutes}
              disabled={hour === "24"}
              onChange={({ currentTarget }) => {
                let val = currentTarget.value;
                if (val === "") {
                  setMinutes("");
                  return;
                }
                const n = Number(val);
                if (isNaN(n)) return;
                if (n < 0) val = "0";
                if (n > 59) val = "59";
                setMinutes(val);
              }}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-sm btn-outline-default"
          disabled={isInvalid}
          onClick={doSubmit}
        >
          <i className="fa fa-check" aria-hidden="true"></i> Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddWorkingHrs;
